<template>
	<div class="content text-white">
		<div class="text-3.5xl mb-8">Withdrawal</div>

		<WithdrawalNav class="mb-3" />

		<div class="grid grid-cols-70-30 gap-12">
			<div>
				<div class="card flex justify-between items-center rounded-b-none p-5 mb-0.5">
					<div class="">
						<div class="text-sm font-bold mb-1.5">Riwayat wIthdrawal</div>
						<div class="text-xs">Anda belum memiliki riwayat transaksi</div>
					</div>

					<router-link to="/withdrawal/riwayat-withdrawal-tunai">
						<button class="btn bg-theme">Lihat Riwayat</button>
					</router-link>
				</div>

				<div class="card mb-0.5 p-5">
					<div class="flex justify-between items-center flex--same-width mb-5">
						<div class="text-sm font-bold">Rekening Penerima</div>

						<div v-if="isLoadingGetBankList" class="text-right">
							<Loader />
						</div>
						<Select v-else :options="rekeningOptions" v-model="rekeningChosen" />
					</div>

					<div class="flex justify-end items-center mb-5">
						<router-link :to="{ name: 'Add Bank Account' }">
							<div class="text-xs font-medium text-theme cursor-pointer">Tambah Rekening Bank</div>
						</router-link>
					</div>

					<div class="flex justify-between flex--same-width mb-3">
						<div class="text-sm font-bold">Masukkan Nominal</div>
						<div>
							<InputComponent :is-prepend="true" :numberOnly="true" placeholder="Minimal penarikan Rp 10000"
								v-model="nominalIdr">
								<template v-slot:prepend>
									<div class="text-theme font-bold">IDR</div>
								</template>
							</InputComponent>

							<!-- errors -->
							<div v-for="item in withdrawalAmountErrors" :key="item" class="text-xs text-red mt-2">
								{{ item }}
							</div>
						</div>
					</div>

					<div class="flex justify-between flex--same-width mb-3">
						<div class="text-sm font-bold">Detail Penarikan</div>
						<div>
							<textarea class="text-xs w-full" placeholder="Masukkan detail penarikan.."
								v-model="detailPenarikan"></textarea>

							<!-- errors -->
							<div v-for="item in withdrawalDescriptionErrors" :key="item" class="text-xs text-red">
								{{ item }}
							</div>
						</div>
					</div>

				</div>

				<div class="card rounded-t-none p-5">
					<button class="btn bg-theme w-full" @click="reqWithdrawal()" :disabled="isWithdrawalDisabled">Withdraw</button>
				</div>
			</div>

			<div>
				<div class="card rounded-b-none p-5 mb-0.5">
					<div class="flex items-center gap-3 mb-5">
						<div class="text-theme">
							&#11044;
						</div>

						<div class="text-sm font-bold">Saldo RPED Tersedia</div>

						<div class="grow text-theme text-xs text-right"><span class="cursor-pointer"
								@click="goToAccountBalanceHistory()">Detail</span></div>
					</div>

					<div v-if="$store.state.setBalancesApiStatus == 'loading'" class="flex justify-center items-center mb-5">
						<Loader />
					</div>
					<div v-else-if="$store.state.setBalancesApiStatus == 'error'">
						<div class="text-xs text-center mb-5">Failed to retrieve balance</div>
						<button class="btn bg-theme w-full" @click="$store.dispatch('setBalances')">Retry</button>
					</div>

					<div v-else class="text-1.5xl mb-5">
						Rp {{ utils.currencyFormat($store.state.availableTradeBalanceIdr.toFixed(2), 'idr') }}
					</div>

					<div class="mb-5">
						<button class="btn outline bg-transparent w-full" @click="$router.push({ name: 'Riwayat Deposit' })">
							Lihat Riwayat Deposit
						</button>
					</div>

					<div class="flex gap-3 bg-white-2 py-2 px-4">
						<div>
							<IconInfo2 height_prop="1.25rem" width_prop="1.25rem" />
						</div>
						<div class="text-xs text-black">
							Untuk dapat withdraw, saldo tersedia tidak boleh kurang dari Rp10.000, setelah dikurangi biaya penarikan:
							<br>
							&bull; Rp3.500 untuk Bank AGI
							<br>
							&bull; Rp2.500 untuk Bank Lainnya
						</div>
					</div>
				</div>
			</div>
		</div>
		<router-view></router-view>

		<InputOtp ref="inputOtpRef" @submit="submitOtp" @resend="resendOtpFunc" @close="handleCloseOtp"
			titleDefault="Kode OTP Via Email" textDefault="Silakan masukkan kode OTP yang kami kirimkan melalui email Anda"
			:contactDefault="$store.getters.getEmailCencored" />
	</div>
</template>

<script>
import useBankAccount from '../../composable/useBankAccount'

import Alert from '@/components/alert-component/AlertComponent.js'

import WithdrawalNav from './components/WithdrawalNav.vue'
import Select from '../../components/ui/Select.vue'
import InputComponent from '../../components/InputComponent.vue'
import IconInfo2 from '../../components/icons/IconInfo2.vue'
import Loader from '../../components/Loader.vue'
import InputOtp from './components/InputOtp.vue'
import utils from '../../utils'

export default {
	name: 'Withdrawal',

	mixins: [useBankAccount],

	components: {
		WithdrawalNav,
		Select,
		InputComponent,
		IconInfo2,
		Loader,
		InputOtp
	},

	data() {
		return {
			utils: utils,
			rekeningChosen: null,
			nominalIdr: null,
			detailPenarikan: null,

			timer: null,
		}
	},

	computed: {
		rekeningOptions() {
			// Filter bank list to only show the accepted ones
			const bankListApproved = this.bankListApproved.filter((item) => {
				return item.status == 'Verified'
			})

			return bankListApproved.map((item) => {
				return {
					_id: item._id,
					value: item.accountNumber,
					label: item.accountName,
					subLabel: item.bankName + ' - ' + item.accountNumber,
					logo: item.bankLogo,
					type: item.type,
				}
			})
		},

		isWithdrawalDisabled() {
			return !this.rekeningChosen || !this.nominalIdr
		}
	},

	created() {
		this.setBankListApproved()
	},

	mounted() {
		this.timer = this.$refs.inputOtpRef.startTimer(60)
	},

	methods: {
		goToAccountBalanceHistory() {
			this.$store.commit('setReportToShow_mut', 'accountBalanceHistory')
			this.$router.push({ name: 'Reports' })
		},

		async reqWithdrawal() {
			if (!this.rekeningChosen) {
				Alert.error('Please choose a bank account')
				return
			}

			if (!this.nominalIdr) {
				Alert.error('Please input the nominal')
				return
			}

			// Request withdrawal
			await this.addRequestCashWithdrawalsFunc({
				// credit_account_id: "67bd6bfdc38d39992f7af354",
				// transfer_type: "bifast",
				// amount: 10000,
				// description: "coba coba"
				credit_account_id: this.rekeningChosen._id,
				transfer_type: this.rekeningChosen.type,
				amount: this.nominalIdr,
				description: this.detailPenarikan
			})

			this.openInputOtp()
		},

		restartTimer() {
			this.timer.complete()
			this.timer.reset(60)
			this.timer.start()
		},

		setInputOtp() {
			let title, text, contact, mode

			if (this.$store.state.bankAccount.otpModeWithdrawal === 'email') {
				title = 'Kode OTP Via Email'
				text = 'Silakan masukkan kode OTP yang kami kirimkan melalui email Anda'
				contact = this.$store.getters.getEmailCencored
				mode = 'email'
			} else {
				title = 'Kode OTP Via SMS'
				text = 'Silakan masukkan kode OTP yang kami kirimkan melalui SMS Anda'
				contact = this.$store.getters.getPhoneNumberCensored
				mode = 'sms'
			}

			this.$refs.inputOtpRef.setTitle(title)
			this.$refs.inputOtpRef.setText(text)
			this.$refs.inputOtpRef.setContact(contact)
			this.$refs.inputOtpRef.setMode(mode)
			this.$refs.inputOtpRef.clearOtp()
		},

		openInputOtp() {
			// setting up input otp modal
			this.setInputOtp()

			this.$refs.inputOtpRef.openInputOtp()
			this.timer.start()
		},

		/**
		 * Submit the OTP to the server
		 * @param {String} otp The OTP
		 */
		async submitOtp(otp) {
			const payload = {
				otp: otp,
			}

			try {
				// Validate the OTP
				if (this.$store.state.bankAccount.otpModeWithdrawal === 'email') {
					await this.validateOtpEmail(payload, 'withdrawal')
					this.$store.commit('bankAccount/setOtpModeWithdrawal', 'sms')

					// restart timer
					this.restartTimer()

					// set input otp modal to SMS mode
					this.setInputOtp()
				} else {
					await this.validateOtpSms(payload, 'withdrawal')
					this.$refs.inputOtpRef.closeInputOtp()
					this.$router.push({ name: 'Riwayat Withdrawal Tunai' })
				}
			} catch (err) {
				if (err == 'stopTimer') {
					this.timer.complete()
				} else if (err == 'OTPValidateExceededLimit') {
					this.$refs.inputOtpRef.closeInputOtp()
				}
			}
		},

		async resendOtpFunc() {
			try {
				await this.resendOtp('withdrawal')

				// restart timer
				this.restartTimer()
			} catch (err) {

			}
		},

		handleCloseOtp() {
			Alert.open({
				type: 'confirm',
				title: 'Apakah Anda Yakin ingin Keluar?',
				description: 'Jika Anda keluar, proses withdrawal akan dibatalkan (tidak dapat disimpan)',
				onConfirm: () => {
					this.$refs.inputOtpRef.closeInputOtp()
				},
				onDecline: () => {
					return
				}
			})
		},
	}
}
</script>

<style scoped>
.card {
	background-color: var(--grey-4-color);
}
</style>
